'use client'
import { useEffect, useCallback } from "react";
import { runInAction, makeAutoObservable, action, computed, makeObservable, observable } from "mobx";
import { enableStaticRendering } from 'mobx-react-lite';


// NextJS 용 => 서버측 랜더링 하지 않음 
enableStaticRendering(typeof window === 'undefined')

/**
 * 인증관련 스토어 (MOBX)
 */
class AuthStore {
  authStore = {
    accToken: '',
    refToken: '',
    isSignIn: false,
  }
  constructor() {
    makeAutoObservable(this)
  }

  // constructor() {
  //   makeObservable(this, {
  //     authStore: observable,
  //     updToken: action,
  //     updSignIn: action,  
  //     isSignIn: computed
  //   })
  // }

  updToken(token) {
    //console.log('authStore:updToken::', token)

    const jsonValue = JSON.stringify(token);
    localStorage.setItem('@userInfo', jsonValue);

    // this.authStore = {
    //   ...this.authStore, 
    //   accToken:token.accToken, 
    //   refToken:token.refToken
    // };
  }

  delToken() {
    localStorage.removeItem('@userInfo');
  }


  updSignIn(is) {
    runInAction(() => {
      this.authStore = {
        ...this.authStore,
        isSignIn: is
      }
    })
  }

  get accToken() {
    const uInfo = localStorage.getItem('@userInfo');

    const token = (uInfo) ? JSON.parse(uInfo) : null;
    return (token) ? token.accToken : '';
  }

  get refToken() {
    const uInfo = localStorage.getItem('@userInfo');
    const token = (uInfo) ? JSON.parse(uInfo) : null;
    return (token) ? token.refToken : '';
  }

  get isSignIn() {
    try {
      const userinfo = localStorage.getItem('@userInfo');
      return (userinfo) ? true : false; //this.authStore.isSignIn;
    }
    catch (e) {
      return false;
    }

  }

}

export const authStore = new AuthStore();
